import {Component, inject, OnInit} from "@angular/core";
import {KnowledgeBaseService} from "../data-access/knowledge-base.service";
import {CommonModule} from "@angular/common";
import {MatCardModule} from "@angular/material/card";
import {ProductionLine} from "src/app/shared/interfaces/productionLine";
import {HeaderService} from "src/app/services/header.service";
import {SelectionService} from "src/app/services/selection.service";
import {Workstation} from "src/app/shared/interfaces/workstation";
import {RouterLink} from "@angular/router";

@Component({
  selector: "app-kd-workplace-selection",
  templateUrl: "./kd-workplace-selection.component.html",
  styleUrls: ["./kd-workplace-selection.component.scss"],
  standalone: true,
  imports: [CommonModule, MatCardModule, RouterLink],
})
export class KdWorkplaceSelectionComponent implements OnInit {
  knowledgeBaseService = inject(KnowledgeBaseService);
  headerService = inject(HeaderService);
  selectionService = inject(SelectionService);

  ngOnInit() {
    this.knowledgeBaseService.initializeTrigger$.next()
  }

  isProductionLineArray(arr: any): arr is ProductionLine[] {
    return arr.length > 0 && "shortcode" in arr[0];
  }

  isWorkstationArray(arr: any): arr is Workstation[] {
    return arr.length > 0 && "production_line" in arr[0];
  }

  selectOption(item: ProductionLine | Workstation) {
    if ("shortcode" in item) {
      // console.log("productionLine selected");
      this.knowledgeBaseService.selectProductionLine(item.id!);
      this.headerService.setHeaderSubTitle(item.name);
      this.knowledgeBaseService.updateSelectedItems("productionLine", {
        id: item.id!,
        name: item.name!,
        type: "productionLine",
      });
    } else if ("production_line" in item) {
      this.knowledgeBaseService.selectWorkplace(item.id!);
      this.knowledgeBaseService.changeActivePage(1);
      this.knowledgeBaseService.updateSelectedItems("workplace", {
        id: item.id!,
        name: item.name!,
        type: "workplace",
      });
    }
  }

  back() {
    this.knowledgeBaseService.goBack();
  }
}
